import { useContext, useEffect, useReducer, useState } from "react"
import Checkbox from "../../../../Components/Checkbox/Checkbox"
import Radio from "../../../../Components/Radio/Radio"
import { Configuration, ConfiguratorContext } from "../../Contexts/Configuration"
import PlanLayout from "../../Layouts/PlanLayout/PlanLayout"
import OptionProduct from "../../Models/OptionProduct"
import Customer from "../../Requests/CustomerRequest"
import Plan from "../../Models/Plan"
import PlanOption from "../../Models/PlanOption"
import API from "../../Services/API"
import { NavigationNode } from "../../Services/Navigation"
import GroupType from "../../Types/GroupType"
import ViewType from "../../Types/ViewType"
import "./OptionsView.css"
import { CustomerType } from "../../Enums/CustomerType"
import PackageProductsRequest from "../../Requests/PackageProductsRequest"
import { ProductType } from "../../Enums/ProductType"

export interface OptionSelection {
	parentId: number
	defaultProductId: number | null
	productCategory: string
	selection: Map<number, boolean>
}

const OptionsView = () => {
	let context = useContext(ConfiguratorContext)

	let [options, setOptions] = useState<PlanOption[]>([])
	let [selection, setSelection] = useState<OptionSelection[]>(context.options ?? [])
	let [plan, setPlan] = useState<Plan | undefined>(undefined)
	let [error, setError] = useState("")
	let [counter, setCounter] = useState<number>(0)
	let [optionsEndReached, setOptionsEndReached] = useState<boolean>(context.optionsEndReached)
	//let [oldOptionsNumber, setOldOptionsNumber] = useState<number>(0)
	const [, forceUpdate] = useReducer(x => x + 1, 0);

	context.validateOptionsView = () => {
		context.options = selection
		for (var o of options.filter(x => x.products.length > 0 && (x.group_type === GroupType.mandatoryMultipleChoice || x.group_type === GroupType.mandatorySingleChoice))) {
			let d = selection.filter(x => x.parentId === o.id)[0]
			if (d === undefined || [...d.selection].filter(x => x[1]).length === 0) {
				setError("Seleziona tutte le opzioni obbligatorie")
				return false
			}
		}

		if (!context.optionsEndReached) {
			if (!optionsEndReached) {
				setError("E' necessario visionare tutte le opzioni per proseguire")
				return false
			} else {
				context.optionsEndReached = true
			}
		}

		context.voipSelected = isVoiceSelected()

		return true
	}

	var selectionChanged = selection.flatMap(x => [...x.selection].sort((a, b) => a[0] - b[0]).map(x => x[1])).join("")

	useEffect(() => {
		(async () => {
			let customer: Customer = {
				first_name: context.name!,
				last_name: context.surname!,
				email: context.email!,
				pec: context.pec,
				status: "prospect",
				phone: context.phone,
				address: context.address,
				billing_address: context.billingAddress,
				cap: context.cap,
				billing_cap: context.billingCap,
				province: context.province,
				billing_province: context.billingProvince,
				municipality: context.common,
				billing_municipality: context.billingMunicipality,
				city: context.common,
				birth_place: context.birthMunicipality === undefined ? undefined : context.birthMunicipality + ' ' + context.birthProvince,
				fiscal_code: context.fiscalCode,
				vat_number: context.vatNumber,
				sdi: context.sdi,
				gender: context.gender ? 'M' : 'F',
				birthday: context.birthDate,
				civic_number: parseInt(context.civicNumber!),
				billing_civic_number: parseInt(context.billingCivicNumber!),
				type: context.isHomeUse ? CustomerType.Private : CustomerType.Professional,
			}
			let res = await API.createCustomerAsync(customer)
			if (res.success) {
				context.customerId = res.data.id
			}
		}
		)()
		return () => { }
	}, [])

	useEffect(() => {
		(async () => {
			let data = []
			for (var d of selection) {
				data.push({ id: d.parentId, products: [...d.selection].filter(x => x[1]).map(x => x[0]) })
			}

			let request: PackageProductsRequest = { data: data }
			let o = await API.getOptionsAsync(context.selectedOffer!.id, request)
			if (o.success) {
				alignCounter(o.data)
				setOptions(o.data)
				context.packageProducts = o.data
				setSelection(getOptionsSelection(o.data) ?? [])
				checkEndReached()
			}
		})()
		return () => { }
	}, [context.selectedOffer, context.options, context.offerChanged, selectionChanged])

	useEffect(() => {
		(async () => {
			let m = []
			for (var d of selection) {
				m.push({ id: d.parentId, products: [...d.selection].filter(x => x[1]).map(x => x[0]) })
			}
			let p = await API.getPlanAsync(context.selectedOffer!.id, {
				number_portability: context.keepNumber,
				wifi_consultancy: context.wifiCoverageCheck,
				payment_type: context.paymentType !== undefined ? context.paymentType.name : '',
				payment_mode: context.paymentMode !== undefined ? context.paymentMode.name : '',
				customer_type_id: context.isHomeUse ? 1 : 2,
				data: m
			})
			if (p.success) {
				setPlan(p.data)
				context.planProducts = p.data.periodic_costs
				context.planProducts = context.planProducts.concat(p.data.una_tantum_costs)
			}
		})()
		return () => { }
	}, [context.selectedOffer, context.options, selection, selectionChanged])

	function moveForward() {
		setCounter(counter + 1)
		checkEndReached()
	}

	function checkEndReached() {
		var reached = true
		if (options.filter(x => x.products.length > 0 && x.is_visible)[counter + 2] !== undefined) reached = false
		if (!context.optionsEndReached) {
			if (reached) {
				setOptionsEndReached(true)
			}
		}
	}

	function alignCounter(newOptions: PlanOption[]) {
		if (options.length === 0) return
		let filteredNewOptions = newOptions.filter(x => x.products.length > 0 && x.is_visible)
		let filteredCurrentOptions = options.filter(x => x.products.length > 0 && x.is_visible)
		setCounter(filteredNewOptions.findIndex(x => x.id === filteredCurrentOptions[counter].id))
	}

	function getOptionsSelection(planOptions: PlanOption[]): OptionSelection[] {
		let newSelection: OptionSelection[]
		if (selection.length === 0) {
			console.log("test")
			newSelection = planOptions.map<OptionSelection>(x => {
				return {
					parentId: x.id,
					defaultProductId: x.default_product_id,
					productCategory: x.product_category,
					selection: new Map<number, boolean>(
						x.products.map((y, i) => [y.id, (
							(x.group_type === GroupType.mandatoryMultipleChoice || x.group_type === GroupType.mandatorySingleChoice)
							&& x.default_product_id !== null
							&& y.id === x.default_product_id
							&& !x.is_visible)
						])
					)
				}
			})
		} else {
			newSelection = planOptions.map<OptionSelection>(x => {
				if ((x.group_type === GroupType.mandatoryMultipleChoice || x.group_type === GroupType.mandatorySingleChoice)
					&& x.default_product_id !== null
					&& !x.is_visible) {
					return {
						parentId: x.id,
						defaultProductId: x.default_product_id,
						productCategory: x.product_category,
						selection: new Map<number, boolean>(
							x.products.map((y, i) => [y.id, getMandatoryProductSelection(x.id, y.id, x.default_product_id!)])
						)
					}
				} else {
					return {
						parentId: x.id,
						defaultProductId: x.default_product_id,
						productCategory: x.product_category,
						selection: new Map<number, boolean>(
							x.products.map((y, i) => [y.id, getProductSelection(x.id, y.id)])
						)
					}
				}

			})
		}
		return newSelection
	}

	function getMandatoryProductSelection(optionId: number, productId: number, defaultProductId: number): boolean {
		let option: OptionSelection = selection!.filter(x => x.parentId === optionId)[0]
		if (option === undefined) return false
		let atLeastOneTrue = false
		option.selection.forEach(element => {
			if (element === true) atLeastOneTrue = true
		});
		if (!atLeastOneTrue && productId === defaultProductId) return true
		return option.selection.get(productId) ?? false
	}

	function getProductSelection(optionId: number, productId: number): boolean {
		let option: OptionSelection = selection!.filter(x => x.parentId === optionId)[0]
		if (option === undefined) return false
		return option.selection.get(productId) ?? false
	}

	function isVoiceSelected(): boolean {
		let voiceSelected = false

		options.forEach(x => x.products.forEach(function (y) {
			if (getProductSelection(x.id, y.id) && y.type === ProductType.Voice) voiceSelected = true
		}))

		return voiceSelected
	}

	const getOptionFrame = (option: PlanOption) => {
		return (
			<div className="options-view-frame" key={option.id}>
				<div className="options-view-frame-title">{option.name}{option.group_type === GroupType.mandatoryMultipleChoice || option.group_type === GroupType.mandatorySingleChoice ? '*' : ''}</div>
				<div className="options-view-frame-list">
					{option.products.map(x => getOptionProductFrame(selection.filter(y => y.parentId === option.id)[0], option.group_type, x))}
				</div>
			</div>
		)
	}

	const getBackArrow = () => {
		var hide = true
		if (counter > 0) hide = false
		return (
			<button style={hide ? { display: 'none' } : {}} className="arrow-button" onClick={() => setCounter(counter - 1)}>
				<img src="../assets/left.png" alt="BackArrow"></img>
				<div className="arrow-text">
					Opzioni <br></br> Precedenti
				</div>
			</button>
		)
	}

	const getNextArrow = () => {
		var hide = true
		if (options.filter(x => x.products.length > 0 && x.is_visible)[counter + 1] !== undefined) hide = false
		return (
			<button style={hide ? { display: 'none' } : {}} className="arrow-button" onClick={() => moveForward()}>
				<div className="arrow-text">
					Altre <br></br> Opzioni
				</div>
				<img src="../assets/right.png" alt="NextArrow"></img>
			</button>
		)
	}

	const getOptionProductFrame = (s: OptionSelection, type: GroupType, product: OptionProduct) => {
		return (
			<div key={product.id} className="options-view-product-frame">
				{type === GroupType.mandatorySingleChoice || type === GroupType.optionalSingleChoice ?
					<Radio checked={s.selection.get(product.id)} onChange={() => {
						for (let k of s.selection.keys()) {
							let old = s.selection.get(k)
							var n = false
							if (k === product.id) {
								n = !old
							}
							else {
								n = false
							}
							s.selection.set(k, n)
						}
						forceUpdate()
					}} />
					:
					<Checkbox title="" checked={s.selection.get(product.id)!} onChange={() => {
						let old = s.selection.get(product.id)
						if (!(type === GroupType.mandatoryMultipleChoice && old && [...s.selection].filter(x => x[1]).length === 1)) {
							s.selection.set(product.id, !old)
						}
						forceUpdate()
					}} />
				}
				<div style={{ fontSize: "20px", fontWeight: "500" }}>{product.name}</div>
				<div style={{ textAlign: "center" }}>{product.description}</div>
				<div>{product.formatted_price}</div>
			</div>
		)
	}

	var option = options.filter(x => x.products.length > 0 && x.is_visible)[counter]


	return (
		<PlanLayout plan={plan}>
			<div className="options-view-container">
				<div className="label-error" style={{ fontSize: '30px' }}>{error}</div>
				<div className="options-view-column">
					<div className="options-view-row">
						{option !== undefined ? getOptionFrame(option) : null}
					</div>
					<div className="options-view-arrow-row">
						{getBackArrow()}
						{getNextArrow()}
					</div>
				</div>
			</div>
		</PlanLayout>
	)
}

const OptionsNode: NavigationNode = {
	content: () => <OptionsView />,
	previous: () => ViewType.offers,
	next: (context: Configuration) => context.voipSelected ? ViewType.portabilityNumber : ViewType.paymentMode,
	percentage: 72
}

export default OptionsNode
